import { Text } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { FormField } from '../../../../../components/FormField'
import { SearchableSelect } from '../../../../../components/Select'
import { baseEstablishment, IEstablishmentTemplateForm } from '../../establishments/establishmentForm'
import { EstablishmentsEditor } from '../../establishments/EstablishmentsEditor'
import { EditionForm, SeriesForm } from './eventSeriesFormShared'

interface IProps {
  form: SeriesForm
  patchSeries: (patch: Partial<SeriesForm>) => void
  fieldErrors: Record<string, string[]>
  setFieldErrors: Dispatch<SetStateAction<Record<string, string[]>>>
  saving: boolean
  editionNumber: (edition: EditionForm) => number
  editionOptionLabel: (ed: EditionForm) => string
}

/**
 * "Produtos e Serviços" da série (ABRA-317): modelos de estabelecimento, aplicados às edições
 * como os ingressos — cada edição recebe a sua cópia (com estoque próprio), e salvar a série
 * regrava as cópias.
 */
export function EstablishmentsTab({
  form,
  patchSeries,
  fieldErrors,
  setFieldErrors,
  saving,
  editionNumber,
  editionOptionLabel
}: IProps) {
  return (
    <>
      <Text variant="caption" mb={4}>
        Cada estabelecimento é criado de forma independente em cada edição selecionada (estoque separado por edição).
        Salvar a série regrava nas edições o que foi definido aqui.
      </Text>

      {form.editions.length === 0 ? (
        <Text variant="caption">Adicione ao menos uma edição para cadastrar estabelecimentos.</Text>
      ) : (
        <EstablishmentsEditor<IEstablishmentTemplateForm>
          establishments={form.establishment_templates}
          onChange={(establishment_templates) => patchSeries({ establishment_templates })}
          errorKey="establishment_templates"
          fieldErrors={fieldErrors}
          setFieldErrors={setFieldErrors}
          saving={saving}
          createEstablishment={() => ({
            ...baseEstablishment(),
            // Um modelo novo já nasce em todas as edições, como o ingresso.
            edition_indexes: form.editions.map((_, i) => i)
          })}
          renderExtra={(template, index) => (
            <FormField
              label="Aplicar às edições"
              error={fieldErrors[`establishment_templates.${index}.edition_indexes`]}
              isRequired
              mt={4}
            >
              <SearchableSelect<number>
                isMulti
                options={form.editions
                  .map((ed, i) => ({ ed, value: i }))
                  .sort((a, b) => editionNumber(a.ed) - editionNumber(b.ed))
                  .map(({ ed, value }) => ({ value, label: editionOptionLabel(ed) }))}
                value={template.edition_indexes.filter((i) => i < form.editions.length)}
                onChange={(editionIndexes) =>
                  patchSeries({
                    establishment_templates: form.establishment_templates.map((tpl, i) =>
                      i === index ? { ...tpl, edition_indexes: editionIndexes } : tpl
                    )
                  })
                }
                placeholder="Selecione as edições"
                entity="edição"
                feminine
                isDisabled={saving}
              />
            </FormField>
          )}
        />
      )}
    </>
  )
}
